export default "__VITE_ASSET__CMrIq3CS__"